import Vue from 'vue'
import Router from 'vue-router'


Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'layout',
      component: () => import('../views/Index.vue'),
      children:[
        {
          path: '/mis',
          name: 'mis',
          component: () => import('../views/mis/Index.vue')
        },
        {
          path: '/mis_cashier',
          name: 'mis_cashier',
          component: () => import('../views/mis/cashier/Index.vue')
        },
        {
          path: '/mis_setting',
          name: 'mis_setting',
          component: () => import('../views/mis/setting/Index.vue')
        },  {
          path: '/mis_password',
          name: 'mis_password',
          component: () => import('../views/mis/setting/PasswordView')
        },
        {
          path: '/mis_test',
          name: 'mis_test',
          component: () => import('../views/mis/test/Index.vue')
        },
        {
          path: '/mis_seturl',
          name: 'mis_seturl',
          component: () => import('../views/mis/setting/seturl/Index.vue'),
        },
        {
          path: '/mis_terBind',
          name: 'mis_terBind',
          component: () => import('../views/mis/setting/terBind/Index.vue'),
        }, {
          path: '/mis_terInfo',
          name: 'mis_terInfo',
          component: () => import('../views/mis/setting/terInfo/Index.vue'),
        },
        {
          path: '/mis_upload',
          name: 'mis_upload',
          component: () => import('../views/mis/setting/upload/Index.vue'),
        },

        {
          path: '/mis_query',
          name: 'mis_query',
          component: () => import('../views/mis/query/Index.vue'),
        },
        {
          path: '/mis_posRefund',
          name: 'mis_posRefund',
          component: () => import('../views/mis/query/refund/Index.vue'),
        },

        {
          path: '/mis_queryLocal',
          name: 'mis_queryLocal',
          component: () => import('../views/mis/query/queryLocal/Index.vue')
        },        {
          path: '/mis_unkownTrade',
          name: 'mis_unkownTrade',
          component: () => import('../views/mis/query/queryUnkown/Index.vue')
        },
        {
          path: '/mis_queryDiscount',
          name: 'mis_queryDiscount',
          component: () => import('../views/mis/query/queryDiscount/Index.vue')
        }
        ,{
          path: '/mis_notifyExc',
          name: 'mis_notifyExc',
          component: () => import('../views/mis/query/notifyExc/Index.vue')
        },
        {
          path: '/mis_delcache',
          name: 'mis_delcache',
          component: () => import('../views/mis/setting/delcache/Index.vue')
        },
        {
          path: '/mis_maintenance',
          name: 'mis_maintenance',
          component: () => import('../views/mis/setting/maintenance/Index.vue')
        },

        {
          path: '/mis_push',
          name: 'mis_push',
          component: () => import('../views/mis/setting/push/Index.vue')
        },
        {
          path: '/mis_print',
          name: 'mis_print',
          component: () => import('../views/mis/print/Index.vue')
        },
        {
          path: '/mis_repush',
          name: 'mis_repush',
          component: () => import('../views/mis/repush/Index.vue')
        },
        {
          path: '/mis_actInfo',
          name: 'mis_actInfo',
          component: () => import('../views/mis/query/actinfo/Index.vue')
        } ,
        {
          path: '/mis_terBind',
          name: 'mis_terBind',
          component: () => import('../views/mis/setting/terBind/Index.vue'),
        },
        {
          path: '/mis_discount',
          name: 'mis_discount',
          component: () => import('../views/mis/setting/discount/Index.vue'),
        },
      
         {
          path: '/mis_channel',
          name: 'mis_channel',
          component: () => import('../views/mis/setting/channel/Index.vue'),
        },

        {
          path: '/mis_disCashier',
          name: 'mis_disCashier',
          component: () => import('../views/mis/discashier/Index.vue')
        },








        {
          path: '/hst',
          name: 'hst',
          component: () => import('../views/hst/Index.vue')
        },
        {
          path: '/cashier',
          name: 'cashier',
          component: () => import('../views/hst/cashier/Index.vue')
        },
        {
          path: '/disCashier',
          name: 'disCashier',
          component: () => import('../views/hst/discashier/Index.vue')
        },    {
          path: '/refund',
          name: 'refund',
          component: () => import('../views/hst/refund/Index.vue')
        },
        {
          path: '/test',
          name: 'test',
          component: () => import('../views/hst/test/Index.vue')
        },
        {
          path: '/mis_pay',
          name: 'mis_pay',
          component: () => import('../views/mis/trade/Index.vue')
        },
        {
          path: '/query',
          name: 'query',
          component: () => import('../views/hst/query/Index.vue'),
        },
        {
          path: '/setting',
          name: 'setting',
          component: () => import('../views/hst/setting/Index.vue'),
        },
        {
          path: '/seturl',
          name: 'seturl',
          component: () => import('../views/hst/setting/seturl/Index.vue'),
        },
        {
          path: '/terBind',
          name: 'terBind',
          component: () => import('../views/hst/setting/terBind/Index.vue'),
        }, {
          path: '/terInfo',
          name: 'terInfo',
          component: () => import('../views/hst/setting/terInfo/Index.vue'),
        }, {
          path: '/authority',
          name: 'authority',
          component: () => import('../views/hst/setting/authority/Index.vue'),
        },
        {
          path: '/upload',
          name: 'upload',
          component: () => import('../views/hst/setting/upload/Index.vue'),
        },
        {
          path: '/trade',
          name: 'trade',
          component: () => import('../views/hst/query/trade/Index.vue')
        }, {
          path: '/actInfo',
          name: 'actInfo',
          component: () => import('../views/hst/query/actinfo/Index.vue')
        }, {
          path: '/queryLocal',
          name: 'queryLocal',
          component: () => import('../views/hst/query/queryLocal/Index.vue')
        }, {
          path: '/qrquery',
          name: 'qrquery',
          component: () => import('../views/hst/query/qrquery/Index.vue')
        },  {
          path: '/luckDraw',
          name: 'luckDraw',
          component: () => import('../views/hst/query/luckDraw/Index.vue')
        },  {
          path: '/posvoid',
          name: 'posvoid',
          component: () => import('../views/hst/refund/posvoid/Index.vue')
        }, {
          path: '/delcache',
          name: 'delcache',
          component: () => import('../views/hst/setting/delcache/Index.vue')
        }, {
          path: '/disRefund',
          name: 'disRefund',
          component: () => import('../views/hst/refund/disrefund/Index.vue')
        }, {
          path: '/qrRefund',
          name: 'qrRefund',
          component: () => import('../views/hst/refund/qrrefund/Index.vue')
        },{
          path: '/notifyExc',
          name: 'notifyExc',
          component: () => import('../views/hst/query/notifyExc/Index.vue')
        },{
          path: '/quickCashier',
          name: 'quickCashier',
          component: () => import('../views/hst/query/quickCashier/Index.vue')
        }, {
          path: '/backRefund',
          name: 'backRefund',
          component: () => import('../views/hst/refund/refund/Index.vue')
        },
        // 桌边付
        {
          path: '/mis_zbf',
          name: 'mis_zbf',
          component: () => import('../views/mis/zbf/Index.vue'),
        }, 
        {
          path: '/mis_zbf_delonix_tableBox',
          name: 'mis_zbf_delonix_tableBox',
          component: () => import('../views/mis/zbf/delonix/tableBox.vue'),
        },
        {
          path: '/mis_zbf_luxsys_tableBox',
          name: 'mis_zbf_luxsys_tableBox',
          component: () => import('../views/mis/zbf/luxsys/tableBox.vue'),
        },
        {
          path: '/mis_zbf_delonix_orderList',
          name: 'mis_zbf_delonix_orderList',
          component: () => import('../views/mis/zbf/delonix/orderList.vue'),
        }, 
        {
          path: '/mis_zbf_delonix_order',
          name: 'mis_zbf_delonix_order',
          component: () => import('../views/mis/zbf/delonix/order.vue'),
        },
        {
          path: '/mis_zbf_luxsys_order',
          name: 'mis_zbf_luxsys_order',
          component: () => import('../views/mis/zbf/luxsys/order.vue'),
        },
        {
          path: '/mis_zbf_shangrila_orderList',
          name: 'mis_zbf_shangrila_orderList',
          component: () => import('../views/mis/zbf/shangrila/orderList.vue'),
        },
        {
          path: '/mis_zbf_shangrila_settledOrderList',
          name: 'mis_zbf_shangrila_settledOrderList',
          component: () => import('../views/mis/zbf/shangrila/settledOrderList.vue'),
        },
        {
          path: '/mis_zbf_shangrila_paymentRecord',
          name: 'mis_zbf_shangrila_paymentRecord',
          component: () => import('../views/mis/zbf/shangrila/paymentRecord.vue'),
        },
        {
          path: '/mis_zbf_shangrila_verifyRecord',
          name: 'mis_zbf_shangrila_verifyRecord',
          component: () => import('../views/mis/zbf/shangrila/verifyRecord.vue'),
        },
        {
          path: '/mis_zbf_shangrila_order',
          name: 'mis_zbf_shangrila_order',
          component: () => import('../views/mis/zbf/shangrila/order.vue'),
        }, 
      ]
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js